/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CollaborateurBriquesPlateformeDto } from './CollaborateurBriquesPlateformeDto';
import {
    CollaborateurBriquesPlateformeDtoFromJSON,
    CollaborateurBriquesPlateformeDtoFromJSONTyped,
    CollaborateurBriquesPlateformeDtoToJSON,
    CollaborateurBriquesPlateformeDtoToJSONTyped,
} from './CollaborateurBriquesPlateformeDto';

/**
 * 
 * @export
 * @interface GetCollaborateursBriquesPlateformeResponse
 */
export interface GetCollaborateursBriquesPlateformeResponse {
    /**
     * 
     * @type {Array<CollaborateurBriquesPlateformeDto>}
     * @memberof GetCollaborateursBriquesPlateformeResponse
     */
    items: Array<CollaborateurBriquesPlateformeDto>;
}

/**
 * Check if a given object implements the GetCollaborateursBriquesPlateformeResponse interface.
 */
export function instanceOfGetCollaborateursBriquesPlateformeResponse(value: object): value is GetCollaborateursBriquesPlateformeResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetCollaborateursBriquesPlateformeResponseFromJSON(json: any): GetCollaborateursBriquesPlateformeResponse {
    return GetCollaborateursBriquesPlateformeResponseFromJSONTyped(json, false);
}

export function GetCollaborateursBriquesPlateformeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCollaborateursBriquesPlateformeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CollaborateurBriquesPlateformeDtoFromJSON)),
    };
}

export function GetCollaborateursBriquesPlateformeResponseToJSON(json: any): GetCollaborateursBriquesPlateformeResponse {
    return GetCollaborateursBriquesPlateformeResponseToJSONTyped(json, false);
}

export function GetCollaborateursBriquesPlateformeResponseToJSONTyped(value?: GetCollaborateursBriquesPlateformeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CollaborateurBriquesPlateformeDtoToJSON)),
    };
}

